
//function for google tag case_details
export function caseInfo(props) {
  window.dataLayer.push({
    event: "Case_view",
    case_name: props.cases,
    case_numbers: props.caseNumber,
  });
}
